import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { revealFetcher, RevealRequestInit } from "../revealFetch";

type PostOptions = {
  defaultErrorMessage?: string;
} & RevealRequestInit;

export const useRevealPostApi = <T, R = any>(
  path: string,
  { defaultErrorMessage, ...fetchOptions }: PostOptions
) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const [response, setResponse] = useState<R>();

  const auth0 = useAuth0();

  const onError = (status: number | string) => {
    setError(defaultErrorMessage || "Error posting data");
    console.error(`Error posting to: ${path}. Status: ${status}`);
  };

  /**
   * By default, sends a POST request and stringifies the optional payload.
   *
   * Payload will usually contain data unless you are doing a DELETE.
   *
   * @param payload optional payload
   */
  const post = async (payload?: T) => {
    setError(undefined);
    setLoading(true);

    try {
      const res = await revealFetcher(auth0).fetch(path, {
        method: "POST",
        body: payload != null ? JSON.stringify(payload) : undefined,
        ...fetchOptions
      });
      if (res.ok) {
        // JSON conversion will fail if there is no response body
        if (res.status !== 204) {
          setResponse(await res.json());
        }
      } else {
        onError(res.status);
      }
      setLoading(false);
      return res;
    } catch (e) {
      setLoading(false);
      onError(`UNHANDLED ERROR: ${e}`);
    }
  };

  return { post, loading, error, response };
};
